// extracted by mini-css-extract-plugin
export default {"collection_element":"AuthorCollection_collection_element__1nx6u","collection_element_text":"AuthorCollection_collection_element_text__iT-4i"};